import { render, staticRenderFns } from "./indexmap.vue?vue&type=template&id=50793945&scoped=true"
var script = {}
import style0 from "./indexmap.vue?vue&type=style&index=0&id=50793945&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50793945",
  null
  
)

export default component.exports